"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Layout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/material/styles");

var _WhiteLabel = _interopRequireDefault(require("./WhiteLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FOOTER_SIZE = 30;
const PADDING_TOP = '10vh';
const PADDING_BOTTOM = 32;
const maxWidthValues = {
  xs: '444px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px'
};
const Container = (0, _styles.styled)('div', {
  name: 'Container',
  shouldForwardProp: prop => prop !== 'includefooter' && prop !== 'usecenteredview'
})(props => {
  var _props$paddingtop;

  return {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: props.background || '#B3C0C3',
    marginBottom: props.usecenteredview ? props.includefooter ? `${FOOTER_SIZE}px` : 0 : 0,
    [`${props.usecenteredview && props.theme.breakpoints.up('sm')}`]: {
      paddingTop: (_props$paddingtop = props.paddingtop) !== null && _props$paddingtop !== void 0 ? _props$paddingtop : PADDING_TOP,
      paddingBottom: `${PADDING_BOTTOM}px`,
      overflowX: 'auto'
    }
  };
});
const Top = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== 'roundedtop' && prop !== 'usecenteredview' && prop !== 'maxwidth',
  name: 'Top'
})(props => ({
  [props.theme.breakpoints.up('sm')]: { ...(props.roundedtop && props.usecenteredview && {
      '& > *:first-of-type': {
        borderTopRightRadius: props.borderradius || 20,
        borderTopLeftRadius: props.borderradius || 20
      }
    }),
    ...(props.maxwidth !== false && props.usecenteredview === false && {
      maxWidth: maxWidthValues[props.maxwidth],
      marginLeft: 'auto',
      marginRight: 'auto'
    })
  }
}));
const Center = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== 'usecenteredview' && prop !== 'maxwidth',
  name: 'Center'
})(props => ({
  paddingLeft: props.paddingleft || 16,
  paddingRight: props.paddingright || 16,
  paddingTop: props.paddingtop || 24,
  paddingBottom: 24,
  [props.theme.breakpoints.down('sm')]: {
    flex: '1 1 100%'
  },
  [props.theme.breakpoints.up('sm')]: {
    paddingLeft: props.paddingleft || 48,
    paddingRight: props.paddingright || 48,
    ...(props.maxwidth !== false && props.usecenteredview === false && {
      maxWidth: maxWidthValues[props.maxwidth],
      marginLeft: 'auto',
      marginRight: 'auto'
    })
  },
  [`${props.theme.breakpoints.up('lg')} and (min-height: 1000px)`]: {
    paddingTop: props.paddingtop || 48
  }
}));
const Bottom = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== 'usecenteredview' && prop !== 'showfooter' && prop !== 'maxwidth',
  name: 'Bottom'
})(props => ({
  paddingLeft: props.paddingleft || 16,
  paddingRight: props.paddingright || 16,
  paddingBottom: props.paddingbottom ? props.paddingbottom : props.usecenteredview ? 16 : 16 + (props.showfooter ? FOOTER_SIZE : 0),
  [props.theme.breakpoints.down('sm')]: {
    flex: '0 1 0'
  },
  [props.theme.breakpoints.up('sm')]: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingLeft: props.paddingleft || 48,
    paddingRight: props.paddingright || 48,
    paddingBottom: props.paddingbottom ? props.paddingbottom : props.usecenteredview ? 24 : 24 + (props.showfooter ? FOOTER_SIZE : 0),
    ...(props.maxwidth !== false && props.usecenteredview === false && {
      maxWidth: maxWidthValues[props.maxwidth],
      marginLeft: 'auto',
      marginRight: 'auto'
    })
  },
  [`${props.theme.breakpoints.up('lg')} and (min-height: 1000px)`]: {
    paddingLeft: props.paddingleft || 48,
    paddingRight: props.paddingright || 48,
    paddingBottom: props.paddingbottom ? props.paddingbottom : props.usecenteredview ? 48 : 48 + (props.showfooter ? FOOTER_SIZE : 0)
  }
}));
const WhiteLabelStyled = (0, _styles.styled)(_WhiteLabel.default, {
  name: 'WhiteLabel'
})(props => ({
  position: 'fixed',
  height: FOOTER_SIZE,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 2,
  [props.theme.breakpoints.up('sm')]: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0
  }
}));
const Content = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== 'usecenteredview',
  name: 'Content'
})(props => ({
  background: props.background || props.theme.palette.background.default,
  margin: 'auto',
  position: 'relative',
  zIndex: 1,
  [props.theme.breakpoints.down('sm')]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  [props.theme.breakpoints.up('sm')]: {
    minHeight: props.usecenteredview ? props.height || 640 - props.paddingbottom : `calc(100% - ${props.bottomsafearea}px)`,
    height: 'min-content',
    width: props.usecenteredview ? props.width || 460 : '100%',
    borderRadius: props.usecenteredview ? props.borderradius || 20 : 0,
    border: props.border || '',
    paddingBottom: props.usecenteredview ? props.paddingbottom : props.bottomsafearea - 2,
    ...(props.usecenteredview && {
      boxShadow: props.boxshadow || '0px 8px 12px rgba(0, 44, 56, 0.08)'
    })
  },
  [`${props.theme.breakpoints.up('lg')} and (min-height: 1000px)`]: {
    minHeight: props.usecenteredview ? props.height || 800 - props.paddingbottom : `calc(100% - ${props.bottomsafearea}px)`,
    width: props.usecenteredview ? props.width || 640 : '100%'
  }
}));

const Layout = ({
  children,
  containerStyle,
  containerPaddingTop,
  containerBackground,
  style,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  useCenteredView = true,
  showFooter = true,
  background,
  shadow,
  borderRadius,
  border,
  width,
  minHeight,
  roundedTop = true,
  top,
  bottom,
  maxWidth = 'sm'
}) => {
  const [footerHeight, setFooterHeight] = (0, _react.useState)(0);

  const footerObserver = _react.default.useRef(new ResizeObserver(entries => {
    setFooterHeight(Math.round(entries[0].contentRect.height));
  }));

  const footerRef = _react.default.useCallback(container => {
    if (container !== null) footerObserver.current.observe(container);else if (footerObserver.current) footerObserver.current.disconnect();
  }, [footerObserver.current]);

  const wrappedChildren = _react.default.createElement(_react.default.Fragment, null, top && _react.default.createElement(Top, {
    borderradius: borderRadius,
    roundedtop: roundedTop,
    usecenteredview: useCenteredView,
    maxwidth: maxWidth
  }, top), _react.default.createElement(Center, {
    paddingtop: paddingTop,
    paddingleft: paddingLeft,
    paddingright: paddingRight,
    usecenteredview: useCenteredView,
    maxwidth: maxWidth
  }, children), bottom && _react.default.createElement(Bottom, {
    paddingbottom: paddingBottom,
    paddingleft: paddingLeft,
    paddingright: paddingRight,
    showfooter: showFooter,
    usecenteredview: useCenteredView,
    maxwidth: maxWidth,
    ref: footerRef
  }, bottom), showFooter && !useCenteredView && _react.default.createElement(WhiteLabelStyled, null));

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Container, {
    style: containerStyle,
    background: containerBackground,
    includefooter: showFooter,
    paddingtop: containerPaddingTop,
    usecenteredview: useCenteredView
  }, _react.default.createElement(Content, {
    style: style,
    boxshadow: shadow,
    background: background,
    borderradius: borderRadius,
    border: border,
    width: width,
    height: minHeight,
    usecenteredview: useCenteredView,
    paddingbottom: footerHeight + 24,
    bottomsafearea: 112
  }, wrappedChildren)), showFooter && useCenteredView && _react.default.createElement(_WhiteLabel.default, {
    style: {
      position: 'fixed',
      height: FOOTER_SIZE,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2
    }
  }));
};

exports.Layout = Layout;
var _default = Layout;
exports.default = _default;